<template>
  <div class="page-wrapper">
    <Transactions @tab="switchTab" v-if="tab_switch == 'transactions'"></Transactions>
    <Settlement @tab="switchTab" v-if="tab_switch == 'settlement'"></Settlement>
  </div>
</template>
<script>
import Transactions from "./Transactions.vue";
import Settlement from "./Settlement.vue";
export default {
  components: {
    Transactions,
    Settlement,
  },
  data: () => ({
    tab_switch: "transactions",
  }),
  watch: {
    "$route.params.tab"(tab) {
      this.tab_switch = tab;
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "finance", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>

